import Obra from './obra';
export default class ObraLocalizacao {
  constructor();
  constructor(proxy: any);
  constructor(proxy?: any) {
    if (proxy != null) {
      for (const key in this) {
        if (proxy[key] != null && (typeof this[key] == typeof proxy[key])) {
          this[key] = proxy[key];
        }
      }
    }
  }

  public codLote: number = 0;
  public codEndereco: number = 0;
  public uf: string = '';
  public municipio: string = '';
  public logradouro: string = '';
  public complemento: string = '';
  public latitude: number | null = null;
  public longitude: number | null = null;

  public obra: Obra | null = null;
  
  public static ValidarLatitudeLongitude(localizacao: ObraLocalizacao) : boolean {

    if (localizacao.latitude == null || localizacao.longitude == null) {
      return false;
    }

    if (localizacao.latitude > 90 || localizacao.latitude < -90 || localizacao.longitude > 180 || localizacao.longitude < -180) {
      return false;
    }

    return true;

  }
}